"use client";

import { IconMinus, IconPlus } from "@tabler/icons-react";
import { Typography } from "../Typography";

type QuantityStepperProps = {
  value: number;
  min?: number;
  max?: number;
  onIncrement: () => void;
  onDecrement: () => void;
  /** Label used for aria-label on the buttons (e.g. "adults", "ticket title") */
  label: string;
};

export const QuantityStepper = ({
  value,
  min = 0,
  max,
  onIncrement,
  onDecrement,
  label,
}: QuantityStepperProps) => {
  const isAtMin = value <= min;
  const isAtMax = max !== undefined && value >= max;

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        aria-label={`Decrease ${label}`}
        onClick={onDecrement}
        disabled={isAtMin}
        className="btn-icon-circle"
      >
        <IconMinus
          size={20}
          strokeWidth={2.2}
          className={isAtMin ? "text-caption" : "text-secondary"}
        />
      </button>

      <Typography variant="button-md">
        {value}
      </Typography>

      <button
        type="button"
        aria-label={`Increase ${label}`}
        onClick={onIncrement}
        disabled={isAtMax}
        className="btn-icon-circle"
      >
        <IconPlus
          size={20}
          strokeWidth={2.2}
          className={isAtMax ? "text-caption" : "text-secondary"}
        />
      </button>
    </div>
  );
};
